import { combineEpics } from "redux-observable";
import { BootstrapEpics } from "./bootstrap/bootstrap.slice";
import { fileEpics } from "./file";
import { projectEpics } from "@/features/projects/stores/project/projectEpic";
import { uploadEpics } from "@/features/upload/stores/upload/uploadEpic";
import { uploadFileEpics } from "@/features/upload/stores/uploadFiles/uploadFileEpic";
import { convertFileEpics } from "@/features/file-management/stores/convertFile/convertFile.slice";
import { drawingsEpic } from "@/features/drawings/stores/drawingsSlice";
import { teamDrivesEpic } from "@/features/drive/stores/teamDrives/teamDrivesSlice";
import { extractionEpics } from "@/features/file-management/pages/FilePage/redux/extraction.slice";
import { modalEpics } from "@/store/modal.slice";
import { deleteFileEpics } from "./deleteFile";
import { archiveFileEpics } from "@/features/file-management/stores/archiveFile";
import { selectedFilesEpic } from "./selectedFiles/selectedFiles.slice";
import { permissionEpics } from "./permission/permissionEpic";
import { organizationUsersEpics } from "@/features/projects/stores/organizationUsers/organizationUsersEpic";
import { navigationEpics } from "./navigation/navigationSlice";
import { organizationsEpics } from "@/features/projects/stores/organizations";
import { preferencesEpics } from "@/features/settings/stores/preferences";
import { contextMenuEpics } from "./contextMenu.slice";
import { authEpics } from "@/features/auth/stores/authSlice";
import { labelEpics } from "@/features/file-management/stores/labelEpic";
import { MoveEpics } from "@/features/file-management/stores/move/moveEpic";
import { folderUploadEpics } from "@/features/upload/stores/folderUpload/folderUploadEpic";
import { driveEpics } from "@/features/drive/stores/drive/driveEpic";
import { workflowEpics } from "@/features/workflow/stores/workflowSlice";
import { dataLoaderEpics } from "@/features/trash/stores/dataLoaderEpic";
import { workflowAnalyticEpics } from "@/features/workflow/stores/workflowAnalyticEpic";
import { groupUserEpics } from "@/features/settings/stores/groupUserEpics";
import { storageEpics } from "@/features/settings/components/StorageManagement/redux/storageEpic";
import { uploadInterceptEpics } from "@/features/upload/stores/uploadIntercept/uploadInterceptEpic";
import { pipelineStatusEpics } from "@/features/file-management/stores/pipelineStatus/pipelineStatus.slice";

const rootEpics = combineEpics(
  ...fileEpics,
  ...BootstrapEpics,
  ...projectEpics,
  ...driveEpics,
  ...uploadEpics,
  ...uploadFileEpics,
  ...convertFileEpics,
  ...drawingsEpic,
  ...teamDrivesEpic,
  ...extractionEpics,
  ...modalEpics,
  ...deleteFileEpics,
  ...archiveFileEpics,
  ...selectedFilesEpic,
  ...permissionEpics,
  ...organizationUsersEpics,
  ...navigationEpics,
  ...organizationsEpics,
  ...preferencesEpics,
  ...contextMenuEpics,
  ...labelEpics,
  ...MoveEpics,
  ...folderUploadEpics,
  ...workflowEpics,
  ...dataLoaderEpics,
  ...workflowAnalyticEpics,
  ...groupUserEpics,
  ...storageEpics,
  ...uploadInterceptEpics,
  ...pipelineStatusEpics,

  authEpics
);

export default rootEpics;
